import components from "./components/index.js";
import pages from "./pages/index.js";
import forms from "@/js/forms";
import initRecaptcha from "./recaptcha.js";
window.addEventListener("DOMContentLoaded", () => {
    components();
    pages();
    forms();
    initRecaptcha();
});
